import { render, staticRenderFns } from "./tabBarNew.vue?vue&type=template&id=29aa9a96&scoped=true"
import script from "./tabBarNew.vue?vue&type=script&lang=js"
export * from "./tabBarNew.vue?vue&type=script&lang=js"
import style0 from "./tabBarNew.vue?vue&type=style&index=0&id=29aa9a96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29aa9a96",
  null
  
)

export default component.exports